
import { Emoji } from 'emoji-mart-vue'
export default {
    name: 'CPEmoji',
    props: ['emo'],
    template: '<emoji :emoji="emo" :alt="emo" set="facebook" :size="16" />',
    components:{
      Emoji
    }
}
